import { fontColor } from 'theme/colors'
import { SVG } from '../styles'

export default function HamburgerIcon() {
  return (
    <SVG viewBox="0 0 448 512" width="40px">
      <path fill={fontColor} d="M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z" />
    </SVG>
  )
}
